import { render } from "./ContactPage.vue?vue&type=template&id=598cbd4b&ts=true"
import script from "./ContactPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/ContactPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "598cbd4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('598cbd4b', __exports__)) {
    api.reload('598cbd4b', __exports__)
  }
  
  module.hot.accept("./ContactPage.vue?vue&type=template&id=598cbd4b&ts=true", () => {
    api.rerender('598cbd4b', render)
  })

}


export default __exports__